import { useState, type ReactNode } from 'react'
import { useIsHydratingRender } from '@/hooks/use-hydrating-render'

const KEEP_SERVER_NODES = { __html: '' }

/**
 * Content props for an element whose subtree is pure markup: no handler, link, state or effect (a locale change reloads
 * the page). The server and a client navigation render `children`. A hydrating client keeps the server's nodes, so
 * React neither runs those components nor claims their nodes. Spread the result on the element and pass it no
 * children. Why it is safe: docs/notes/app/landing.md ("Load cost").
 */
export function useServerMarkup(children: ReactNode) {
  const hydrating = useIsHydratingRender()
  const [keepServerNodes] = useState(() => hydrating && typeof window !== 'undefined')
  return keepServerNodes ? { dangerouslySetInnerHTML: KEEP_SERVER_NODES, suppressHydrationWarning: true } : { children }
}
